// extracted by mini-css-extract-plugin
export default {"root":"IconSocialMedia_root__21ADl"};